import { AntButton } from '@/common/ant-components/AntButton';
import { warningTitle } from '@/common/custom-date-selector-list/helpers';
import {
  ExclamationCircleOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

/**
 * CreateButton component that renders a button with an icon and title, and navigates to a specified path when clicked.
 *
 * @component
 * @example
 * const title = "Create Item";
 * return (
 *   <CreateButton openModal={()=>openModal('create')} title={title} />
 * )
 *
 * @param {Object} props - Component props.
 * @param {function} function.openModal - The fumction to open modal when the button is clicked.
 * @param {string} props.title - The title to be displayed on the button.
 * @returns {React.Element} The rendered component.
 */
const CreateModalButton = ({ title, openModal, fetchData = () => {} }) => {
  const app = useSelector((state) => state?.financialData?.data);

  const isActiveFinancialYear = useSelector(
    (state) => state?.financialData?.data?.isActive,
  );

  const { confirm } = Modal;

  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        event.key === '+' ||
        event.code === 'Equal' ||
        (event.key === '=' && event.shiftKey)
      ) {
        event.preventDefault();
        openModal('create');
        fetchData();
      }
      if (event.code === 'Escape') {
        event.preventDefault();
        navigate(-1);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <div>
      <AntButton
        color="green"
        // className="header-add"
        size="medium"
        onClick={() => {
          if (!isActiveFinancialYear) {
            confirm({
              title: `${warningTitle} (${app?.financialYearStartDate} to ${app?.financialYearEndDate})?`,
              icon: <ExclamationCircleOutlined style={{ color: 'red' }} />,
              onOk: () => {
                openModal('create');
                fetchData();
              },
            });
            return;
          } else {
            (openModal('create'), fetchData());
          }
        }}
      >
        <PlusCircleOutlined />
        {title}
      </AntButton>
    </div>
  );
};

export default CreateModalButton;
